import { AnyAction } from "redux";

const isForbiddenErrorAction = (
  action: AnyAction
): action is { type: string; error: Error } => {
  return action.error?.message === "Forbidden";
};

export default isForbiddenErrorAction;
